import React from "react";
import {
  FaCode,
  FaUsers,
  FaChalkboardTeacher,
  FaCloud,
} from "react-icons/fa";

export default function Personal() {
  const interests = [
    {
      icon: <FaCode />,
      label: "Software Development",
      value:
        "Interested in software engineering, web application development, modern technologies, and building reliable software solutions.",
    },
    {
      icon: <FaUsers />,
      label: "Project & Team Leadership",
      value:
        "Interested in project delivery, team leadership, mentoring developers, and improving software development processes.",
    },
    {
      icon: <FaChalkboardTeacher />,
      label: "Teaching & Mentoring",
      value:
        "Passionate about teaching computer science, mentoring developers, and helping students and professionals improve their technical skills.",
    },
    {
      icon: <FaCloud />,
      label: "Cloud & Emerging Technologies",
      value:
        "Interested in cloud platforms, modern application infrastructure, artificial intelligence, and emerging technologies.",
    },
  ];

  return (
    <section id="personal">
      <h2>Professional Interests</h2>

      <p>
        Harpreet Singh is interested in software development, project
        management, technical leadership, teaching, mentoring, cloud
        technologies, and emerging technology trends.
      </p>

      <div className="card personal-grid">
        {interests.map((item, index) => (
          <div className="personal-item" key={index}>
            <div className="personal-icon">{item.icon}</div>

            <div>
              <strong>{item.label}:</strong> {item.value}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
